import {useEffect, useRef} from 'react';

// Пауза перед прокруткой: секции выше цели еще досчитывают раскладку (сетки
// перемеряют колонки, догружаются картинки) — та же задержка, что у перехода к
// образам отрядов на странице фракции
export const SCROLL_INTO_VIEW_DELAY_MS = 400;

/**
 * Плавно прокрутить страницу к элементу один раз — когда он появился в
 * разметке (например, секция рисуется только после загрузки данных). Пока
 * isReady не стал true, ничего не происходит; после прокрутки хук больше не
 * срабатывает, даже если isReady снова переключится.
 *
 * @param {{current: HTMLElement|null}} ref - цель прокрутки
 * @param {Object} params
 * @param {boolean} params.isEnabled - прокрутка вообще нужна (например,
 *   страницу открыли переходом «к секции»)
 * @param {boolean} params.isReady - цель уже в разметке
 * @param {number} [params.delayMs]
 */
export const useScrollIntoViewWhenReady = (ref, {isEnabled, isReady, delayMs = SCROLL_INTO_VIEW_DELAY_MS}) => {
  const isScrolledRef = useRef(false);

  useEffect(() => {
    if (!isEnabled || !isReady || isScrolledRef.current) {
      return undefined;
    }

    const timeoutId = setTimeout(() => {
      isScrolledRef.current = true;
      ref.current?.scrollIntoView({behavior: 'smooth', block: 'start'});
    }, delayMs);

    return () => clearTimeout(timeoutId);
  }, [ref, isEnabled, isReady, delayMs]);
};
